// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"798":"0dc64a8c","856":"0a49d408","956":"31b1eadb"}[chunkId] + ".chunk.js";
};